import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import cn from 'classnames';

import SidebarMenu from 'components/menu/SidebarMenu.component';
import ClientTagsSplashBottomPanel from 'components/tags/splash/ClientTagsSplashBottomPanel.component';
import ClientTagsSplashTopPanel from 'components/tags/splash/ClientTagsSplashTopPanel.component';
import useWindowScroll from 'hooks/useWindowScroll.hook';
import { withTheme } from 'providers/Theme.provider';
import { selectCurrentSalonCalendarMode } from 'selectors/currentSalon.selectors';

import PadLock from 'lib/components/PadLock';

import CN from './ClientTagsSplashPage.module.scss';

const ClientTagsSplashPage = ({ isBrightMode, isDarkMode, isLightMode }) => {
  useWindowScroll(0, 0);

  return (
    <div
      data-bem="ClientTagsSplashPage"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
        'light-class': isLightMode,
        'dark-class': isDarkMode,
        'bright-class': isBrightMode,
      })}
    >
      <header data-bem="ClientTagsSplashPage__header" className={CN.header}>
        <SidebarMenu />
        <div className={CN.globalNav}>
          <div className={cn(CN.pageName, CN.clientTags)} />
          <nav className={CN.menuList}>
            <ul className={CN.ulScrollMenu} />
          </nav>
        </div>
        <PadLock />
      </header>

      <ClientTagsSplashTopPanel />
      <ClientTagsSplashBottomPanel />
    </div>
  );
};

const mapStateToProps = (state) => ({
  calendarMode: selectCurrentSalonCalendarMode(state),
});

const ClientTagsSplashPageHoc = withRouter(connect(mapStateToProps)(withTheme()(ClientTagsSplashPage)));

export default ClientTagsSplashPageHoc;
